import React, { useState } from "react";
import { Group, Rect, Path, Text } from "react-konva";
import Hoverable from "frontend/ui-components/konva-helpers/hoverable";

interface CarouselButtonProps {
  x: number;
  y: number;
  direction: "previous" | "next";
  onClick: () => void;
}

export const CarouselButton = React.memo(({ x, y, direction, onClick }: CarouselButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const WIDTH = 15;
  const HEIGHT = 18;

  return (
    <Group
      x={x}
      y={y}
      offsetX={WIDTH / 2}
      offsetY={HEIGHT / 2}
      onClick={(e) => {
        e.evt.stopPropagation();
        e.evt.preventDefault();
        onClick();
      }}
    >
      <Hoverable
        width={WIDTH}
        height={HEIGHT}
        cornerRadius={4}
        fill="#000000"
        hoverFill="#000000"
        hoverChange={setIsHovered}
        cursor="pointer"
        opacity={isHovered ? 0.4 : 0.2}
        listening
      />
      {direction === "previous" ? (
        <Group x={WIDTH / 2 - 3} y={HEIGHT / 2 - 5} listening={false}>
          <Path data="M4.5 9L1 5" stroke="white" strokeWidth={1.2} lineCap="round" fill="none" />
          <Path data="M4.5 1L1 5" stroke="white" strokeWidth={1.2} lineCap="round" fill="none" />
        </Group>
      ) : (
        <Group x={WIDTH / 2 - 3} y={HEIGHT / 2 - 5} listening={false}>
          <Path data="M1 1L4.5 5" stroke="white" strokeWidth={1.2} lineCap="round" fill="none" />
          <Path data="M1 9L4.5 5" stroke="white" strokeWidth={1.2} lineCap="round" fill="none" />
        </Group>
      )}
    </Group>
  );
});

CarouselButton.displayName = "CarouselButton";

interface CarouselCounterProps {
  x: number;
  y: number;
  current: number;
  total: number;
}

export const CarouselCounter = React.memo(({ x, y, current, total }: CarouselCounterProps) => {
  const text = `${current}/${total}`;

  const WIDTH = 29;
  const HEIGHT = 16;

  return (
    <Group x={x} y={y - HEIGHT - 2}>
      <Rect x={-WIDTH / 2} width={WIDTH} height={HEIGHT} cornerRadius={4} fill="#1e1e1e" opacity={0.35} />
      <Text
        width={WIDTH}
        height={HEIGHT}
        x={-WIDTH / 2}
        y={-HEIGHT / 2}
        text={text}
        fontSize={10}
        fontFamily="Poppins"
        fill="white"
        align="center"
        verticalAlign="middle"
        letterSpacing={0.174}
        offsetY={-9.5}
      />
    </Group>
  );
});

CarouselCounter.displayName = "CarouselCounter";
